import { useNuxtApp, showError } from '#imports';
import { httpStatus } from '~dsc/utils/http-status';
import { invert } from 'lodash-es';

const INTERNAL_SERVER_ERROR = 500;
const httpStatusInverted = invert(httpStatus);

export const useCmsProxy = async (url, options = {}, route = null) => {
    const { $router, $i18n, $paths, $dsc } = useNuxtApp();
    const defaultPageNamePrefix = 'url___';
    const locale = $i18n.locale.value || 'fi-FI';

    if (options.headers !== 'object') {
        options.headers = {};
    }
    options.headers['x-st1-locale'] = locale;

    if (url === $paths.getEndpoint('page')) {
        if (route && route.name !== `${defaultPageNamePrefix}${$i18n.defaultLocale}`
            && $router.hasRoute(route.name)
        ) {
            return false;
        }

        if (options.query === undefined) {
            options.query = {};
        }

        if (options.query.path && options.query.path !== '/') {
            const queryParts = options.query.path.replace(/^\//, '').split('/');

            if (queryParts[0] === 'preview') {
                queryParts.splice(0, 1);
                options.headers['x-st1-preview'] = true;
            }

            if (queryParts[0] === $i18n.locale.value) {
                queryParts.splice(0, 1);
            }

            options.query.path = queryParts.length > 0 && queryParts[0] !== ''
                ? queryParts.join('/')
                : '/';
        } else {
            options.query.path = '/';
        }
    }

    try {
        const proxyUrl = `/proxy/${url}`;

        const scriptSetup = options.$ === false;
        delete options.$;

        if (!scriptSetup) return await $fetch(proxyUrl, options);

        const useFetchRes = await useFetch(proxyUrl, options);

        if (useFetchRes.error.value) {
            const error = new Error(useFetchRes.error.value);
            error.fatal = useFetchRes.error.value.statusCode >= INTERNAL_SERVER_ERROR;
            error.statusCode = useFetchRes.error.value.statusCode;
            if (url === $paths.getEndpoint('page') || url === $paths.getEndpoint('layout')) {
                throw showError(error);
            } else $dsc.msg.error($i18n.t(`httpMessages.${httpStatusInverted[error.status]}`));
        }

        return useFetchRes;
    } catch (error) {
        if (url === $paths.getEndpoint('page') || url === $paths.getEndpoint('layout')) {
            throw showError({
                statusCode: error.status ?? INTERNAL_SERVER_ERROR,
                fatal: error.status >= INTERNAL_SERVER_ERROR,
                statusMessage: import.meta.dev ? `${$i18n.t(`httpMessages.${httpStatusInverted[error.status]}`)} - ${url} - ${options.query.path}` : $i18n.t(`httpMessages.${httpStatusInverted[error.status]}`),
            });
        } else $dsc.msg.error($i18n.t(`httpMessages.${httpStatusInverted[error.status]}`));
    }
};
